// Single source of truth for Wayly brand copy shared across the web app.
// Mobile mirrors this in mobile/src/config/brand.ts so the two platforms
// cannot drift apart.
export const BRAND_NAME = "Wayly";
export const BRAND_TAGLINE = "AGED CARE, MADE CLEAR";
